export default {
  SUPPORT: { title: "Підтримка", value: 0 },
  PROJECT: { title: "Проект", value: 1 },
};